import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
if (process.env.NODE_ENV === 'development') {
  application.debug = true
}
window.Stimulus   = application

export { application }
